<template>
    <div id="containerSignup" class="text-center" v-if="isAppMobile">        
        <div class="pb-2">
            <h5>{{$t("notHaveLoginPassword")}}</h5>
            <button  id="btnSignup" class="btn btn-info btn-sm" @click.prevent="signup">
                {{$t("signup")}}
            </button>         
        </div>
    </div>
</template>
<script>
    import SharedMixin from './../../mixins/SharedMethods'
    export default {
        name : 'TheContainerSignup',
        mixins: [SharedMixin],
        methods : {
            signup: function () {          
                var urlDestiny = `${this.$store.state.origin}signup`
                window.top.location.href = urlDestiny;          
            }            
        }
    }
</script>
<style>
    
</style>